import styled from 'styled-components';

// Gallery detail view styles
export const Base = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow-y: auto;
`;

export const Header = styled.div`
	padding: 24px 20px;
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};
`;

export const HeaderContent = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
`;

export const BackButton = styled.button`
	display: flex;
	margin-top: 4px;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border-radius: 6px;
	border: none;
	background: transparent;
	color: ${({ theme }) => theme.gray[700]};
	transition: background-color 0.15s ease, color 0.15s ease;
	outline: none;
	padding: 0;
	flex-shrink: 0;

	&:hover {
		background: ${({ theme }) => theme.gray[200]};
		color: ${({ theme }) => theme.gray[1000]};
	}
`;

export const Title = styled.h1`
	font-size: 32px;
	font-weight: 700;
	color: ${({ theme }) => theme.gray[1000]};
	margin: 0;
	flex: 1;
	min-width: 0;
`;

export const HeaderActions = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	flex-shrink: 0;
`;

export const DeleteButton = styled.button`
	font-size: 13px;
	color: ${({ theme }) => theme.gray[600]};
	background: transparent;
	padding: 4px 12px;
	border-radius: 12px;
	border: 1px solid transparent;
	font-weight: 500;
	white-space: nowrap;
	transition: all 0.15s ease;

	&:hover {
		background: ${({ theme }) => theme.red[200]};
		color: ${({ theme }) => theme.red[700]};
		border-color: ${({ theme }) => theme.red[500]};
	}
`;

export const Content = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 24px 20px;
`;

export const PreviewWrapper = styled.div`
	flex: 1;
	width: 100%;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	overflow: hidden;
`;
